import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import store from './app/store';
import classes from './App.module.css'
import Spinner from 'react-bootstrap/Spinner'
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import TodaysEvents from './features/todaysEvents/TodaysEvents'
import Progress from './features/progress/Progress'
import Pictures from './features/pictures/Pictures'
import ProspectDashboard from './features/ProspectDashboard'
import PhotoReel from './features/photoReel/PhotoReel'
import Achievements from './features/achievements/Achievements'
import Messenger from './features/Messenger/Messenger'
import EventsView from './features/eventsView/EventsView'
import ExerciseList from './features/exerciseList/ExerciseList'
import ViewExerciseProgress from './features/exerciseList/ExerciseProgress/ViewExerciseProgress'
import Wearables from './features/Wearables/Wearables'
import Onboarding from './features/onboarding/Onboarding'
import StickyChatToggle from './features/StickyChatToggle/StickyChatToggle'
import SimplifiedNutrition from './features/simplifiedNutrition/SimplifiedNutrition'
import MaxClassSchedule from './features/maxClassSchedule/MaxClassSchedule'
import Metric from './features/Metric/Metric'
import MetricList from './features/MetricList/MetricList'
import GymMetricList from './features/MetricList/GymMetricList'
import AddProgress from './features/Metric/AddProgress'
import ViewPictures from './features/viewPictures/ViewPictures'
import FoodList from './features/foodList/FoodList'
import MAXFoodList from './features/foodList/MAXFoodList'
import Recipes from './features/recipes/Recipes'
import Programs from './features/programs/Programs'
import ProgramsAddEdit from './features/ProgramsAddEdit/ProgramsAddEdit'
import ProgramsEdit from "./features/ProgramsAddEdit/ProgramsEdit";
import ProgramSettings from "./features/programs/ProgramSettings/ProgramSettings";
import Profile from './features/profile/Profile'
import Settings from './features/settings/Settings'
import useBranding from './hooks/useBranding'
import EventEditor from './features/EventEditor/EventEditor'
import EventCreator from './features/EventCreator/EventCreator'
import ParQ from "./features/parQ/ParQ"
import ClientProfile from "./features/ClientProfile/ClientProfile"
import MuscleGroups from "./features/MuscleGroups/MuscleGroups"
import Calendar from "./features/EventList/EventCalendar/EventCalendar.js"
import Modal from "react-bootstrap/Modal";
import LiveClasses from "./features/LiveClasses/LiveClasses";
import MessageCenter from './features/MessageCenter/MessageCenter'
import ApiStatus from "./features/ApiStatus/ApiStatus"
import Blog from "./features/Blog/Blog"
import BlogLiveView from "./features/Blog/LiveView"
import SingleBlog from "./features/Blog/SingleBlog";
import BlogSearch from "./features/Blog/BlogSearch";
import GymCalendar from "./features/GymCalendar"
import UpdateBillingModal from "./features/FinancialsDashboard/Billing/UpdateBillingModal"
import CustomizationDashboard from "./features/CustomizationDashboard/CustomizationDashboard"
import LiteIOS from "./features/CustomizationDashboard/LiteIOS/LiteIOS"
import ResetCurrencyModal from "./features/FinancialsDashboard/Billing/ResetCurrencyModal"
import TopNavPublic from "./features/topNavPublic/TopNavPublic"
import CustomForms from "./features/customForms/customForms"
import Growth from "./features/Growth/Growth"
import FormEditor from "./features/customForms/FormEditor"
import CustomAppSuccess from "./features/customApp/CustomAppSuccess"
import Scheduler from './features/Scheduler/Scheduler';
import ScrollTop from './features/ScrollTop/ScrollTop';
import Merchandise from './features/Merchandise/Merchandise';
import ProgressGraphGrid from './features/Metrics/ProgressGraphGrid';
import AdminDashboard from './features/adminDashboard/AdminDashboard';
import AdminReferrals from './features/AdminReferrals/AdminReferrals';
import Referrals from './features/Referrals/Referrals';
import VideoModal from './features/VideoModal/VideoModal';
import NotificationDashboard from './features/NotificationDashboard/NotificationDashboard'
import NotificationBell from './features/NotificationBell/NotificationBell'
import ClientEmails from "./features/ClientEmails/ClientEmails"
import FinancialsDashboard from "./features/FinancialsDashboard/FinancialsDashboard"
import ProgramEditor from "./features/programs/ProgramEditor/ProgramEditor"
import PayInvoice from "./features/PayInvoice/PayInvoice"
import AIDemo from "./features/AIDemo/AIDemo"
import Button from 'react-bootstrap/Button'
import ResourceReferenceCreatorModal from './features/MessageCenter/ResourceReference/CreatorModal'
import ClientSessionsModal from './features/FinancialsDashboard/Sessions/ClientSessionsModal'
import useCurrentUser from './hooks/useCurrentUser'
import RecipeEditor from "./features/recipes/Editor"
import PWAStart from './features/PWAStart/PWAStart';
import PaymentSetup from './features/PaymentSetup/PaymentSetup';
import AddClient from './features/AddClient/AddClient';
import OnDemand from './features/OnDemand/OnDemand';
import Timer from './features/Timer/Timer';
import MyTrainer from './features/MyTrainer/MyTrainer';
import CrashLogging from './features/crashLogging/CrashLogging';
import PipelineAssignModal from './features/Growth/OnboardingPipelines/AssignModal';
import PipelineAssignmentsEditor from './features/Growth/OnboardingPipelines/AssignmentsEditor';
import {useMenu} from './features/CustomizationDashboard/hooks'

import TryFitSW2 from './features/TryFitSW2';

import MultiFormsModal,{MultiFormsRoute} from './features/customForms/MultiForms'
import ProgramAssignModal from "./features/FinancialsDashboard/Packages/ProgramAssignModal"

import ProspectiveClientViewer from "./features/Growth/Prospects/Viewer"

import useShouldShowFeature from './hooks/useShouldShowFeature'

import {
	getAllClients,
} from "./features/users/usersSlice"

import {
	BrowserRouter as Router,
	Switch,
	Route,
	Link,
	withRouter
} from "react-router-dom"

//component/feature imports
import DevUserOptions from './features/users/DevUserOptions'
import SideNav from './features/sideNav/SideNav'
import EventList from './features/EventList/EventList'
import TopNav from './features/topNav/TopNav'
import Compliance from './features/compliance/Compliance'
import AccountList from './features/AccountList/AccountList'
import Trainers from './features/trainers/Trainers'
import Clients from './features/clients/clients'
import ClientList from './features/ClientList/ClientList'
import AddNewClients from './features/clients/AddNewClients'
import ClientCompliance from './features/clientCompliance/Compliance'
import { updateLayout } from './state/layout'
import { detect } from 'detect-browser';
import { getMobileStatus } from './state/initSlice';
import { envAwarePost } from './util/util';
import CancelAccount from './features/CancelAccount/CancelAccount';
import RecipesPublic from './features/recipes/RecipesPublic';
import OnboardingPipelineEditor from './features/Growth/OnboardingPipelines/Editor';
import ExternalResources from './features/ExternalResources/ExternalResources';
import TrainerPageServices from './features/profile/TrainerPageServices/TrainerPageServices';

//analytics/tracking helper
const trackParams = (params) => {
  if (params.get("message") === "register") {
    //track pageview as signup success

    window.gtag(
      "event",
      "page_view",
      {
        send_to: "AW-1025645460",
        items: [
          {
            id: "signupSuccess",
            location_id: "signupSuccess",
            google_business_vertical: "custom",
          },
        ], //end items
      } //end page_view
    ); //end gtag(...)

    //track pageview as conversion
    window.gtag("event", "conversion", {
      send_to: "AW-1025645460/88FOCNjjzHoQlLeI6QM",
    }); //end gtag(...)

    var capterra_vkey = "33d35c981b64e30883f6a6a1a6c3657f",
      capterra_vid = "2107215",
      capterra_prefix =
        "https:" == document.location.protocol
          ? "https://ct.capterra.com"
          : "http://ct.capterra.com";
    var ct = document.createElement("script");
    ct.type = "text/javascript";
    ct.async = true;
    ct.src =
      capterra_prefix +
      "/capterra_tracker.js?vid=" +
      capterra_vid +
      "&vkey=" +
      capterra_vkey;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(ct, s);
  }
}

const isDevServer = window.location.host.indexOf("localhost:") > -1

//React router does not work with nested fragments
//the following two components fix this so that we
//can implement basic routing account restrictions 
const FragmentSupportingSwitch = ({children}) => {
  const flattenedChildren = [];
  flatten(flattenedChildren, children);
  return React.createElement.apply(React, [Switch, null].concat(flattenedChildren));
}

function flatten(target, children) {
  React.Children.forEach(children, child => {
    if (React.isValidElement(child)) {
      if (child.type === Fragment) {
        flatten(target, child.props.children);
      } else {
        target.push(child);
      }
    }
  });
}

const UpgradeRequired = ()=>{
	return (
		<div style={{
			display:'flex',
			alignItems:'center',
			justifyContent:'center',
			width:'100vw',
			height:'100vh',
			background:'#00041c',
			color:'#fff',
			flexFlow:'column',
			padding:'16px',
			textAlign:'center'
		}}>
			<img src="https://cdn.fitsw.com/assets/img/brand/FitSW-Personal-Trainer-Software-Logo-For-Fitness-Coaches.png"/>

			<strong style={{display:'block',margin:'20px auto'}}>Please, Upgrade to Access FitSW Premium Features</strong>
			<Button 
				variant="success"
				href="/upgrade"
			>
				Click here to see pricing options
			</Button>
		</div>
	)
}

const App = props => {

	const params = new URLSearchParams(window.location.search)
	const isPublic = Boolean(params.get('is_public_api_request'))

	const dispatch = useDispatch()

	const state = store.getState()

	const shouldShowFeature = useShouldShowFeature()

	const user = useCurrentUser()

	console.log(user)

	const accountType = user?.account_type
	const isOwner = user?.is_owner === 1
	const isAdmin = user?.user_id ===  'admin@fitsw.com'
	const isChain = accountType === 'chain'
	const isGym = accountType === 'gym'
	const isTrainer = accountType === 'trainer'
	const isClient = accountType === 'client'
	const isProspect = accountType === 'prospect'
	let guestAccess = false;

	const {status:menuStatus} = useMenu()

	//for viewing public posts
	if (!state.users.current_user) {
		guestAccess = true;
	}

	const [showSideNav, setShowSideNav] = useState(window.innerWidth > 800)
	// const [showSideNav, setShowSideNav] = useState(false)
	const { showBodyContentDrawer } = useSelector(state => state.layout)
	const toggleBodyContentDrawer = () => {
		dispatch(updateLayout({ showBodyContentDrawer: !showBodyContentDrawer }))
	}
	const initStatus = useSelector(state => state.init?.status)
	const statusUserId = useSelector(state => state.init?.statusUserId)
	const customBranding = useBranding()
	
	const showNotificationCenter = useSelector(state => (
		['trainer', 'client'].includes(state.users?.current_user?.account_type)
	))

	const [showUpgradeModal, setShowUpgradeModal] = useState(false)

	const browser = detect();

	useEffect(() => {
		if (browser.name === "ie") {
			setShowUpgradeModal(true)
		}
	}, [])

	useEffect(() => {
		if (!guestAccess) {
			dispatch(getAllClients({
				include_compliance:Number(!isChain)
			}))
		}
	}, [])

	useEffect(()=>{
		const searchParams = new URLSearchParams(window.location.search);
    //track url search params
    trackParams(searchParams);
	},[])

	const urlParams = new URLSearchParams(window.location.search)
	let mobileStatus = urlParams.get('mobile')

	if (mobileStatus == "1") {
		mobileStatus = true;
	} else {
		mobileStatus = false;
	}

	const isLocal = window.location.host.indexOf('localhost') > -1
	//if in react dev server
	const isDev = window.location.host.indexOf('localhost:') > -1
	
	let isLocalOrDev = isLocal || isDev

	if (
		user
		&& !parseInt(user?.premium)
		&& user?.date_created >= '2024-04-24 00:00:00'
		&& user?.account_type !== 'client'
	) {
		return <UpgradeRequired/>
	}

	if (guestAccess) {
		return (
			statusUserId === 'pending' || initStatus === "pending" ?
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					width: '100vw',
					height: '100vh',
					flexFlow: 'column'
				}}>
					<Spinner animation="border" role="status">
						<span className="sr-only">Loading...</span>
					</Spinner>
					<p className="text-center">
						Loading your fitness experience...
					</p>
				</div> :
				<>
					<TopNavPublic />

					<Router>
						<Switch>
							<Route exact path="/:pageAddress/blog/search/" render={() => <BlogSearch />} />

							<Route exact path="/:pageAddress/blog/:postSlug" >
								<SingleBlog />
							</Route>

							<Route exact path="/:pageAddress/blog/">
								<BlogLiveView />
							</Route>
							<Route exact path ="/recipes"> <RecipesPublic/> </Route> 
							<Route 
								component={PayInvoice}
								path="/pay-invoice"
								exact 
							/>
						</Switch>

					</Router>
				</>

		)
	}

	return (
		initStatus === 'pending' ?
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '100vw',
			height: '100vh',
			flexFlow: 'column'
		}}>
			<Spinner animation="border" role="status">
				<span className="sr-only">Loading...</span>
			</Spinner>
			<p className="text-center">
				Loading your fitness experience...
			</p>
		</div> :
		<Router>
			<div className={classes.MainLayout}>
				{(!mobileStatus) && <div
					className={[
						classes.SideContent,
						showSideNav ? classes.Show : '',
						'shadow',
					].join(' ')}
					style={{
						background: customBranding ? customBranding.backgroundColor : ''
					}}
				>
					<button
						onClick={() => setShowSideNav(!showSideNav)}
						className={classes.SideToggle}
						style={{
							background: customBranding ? customBranding.backgroundColor : '',
							color: customBranding ? customBranding.textColor : ''
						}}
					>
						<i className={`fas fa-caret-${showSideNav ? 'left' : 'right'}`}></i>
					</button>
					{/* ------ Side Content Bar ------ */}
					<div className="overflow-hidden" style={{ height: '100%' }}>
						{!isPublic&&<SideNav />}
					</div>
				</div>}
				<div className={classes.MainContent}>
					{/* ------ Top Content Bar ------ */}
					{(!mobileStatus) && <div style={{
						background: customBranding ? customBranding.backgroundColor : ''
					}}
						className={[classes.TopContent].join(' ')} >
						{/*isDevServer && <DevUserOptions />*/}
						{showNotificationCenter &&
							<NotificationBell/>

						}
						<TopNav />
					</div>}
					{/* ------ Body Content Container ------ */}
					<div className={classes.BodyContentContainer}>
						{/* ------ Body Content ------ */}
						<TryFitSW2/>
						<div id="BodyContent" className={classes.BodyContent}>
							{/* !!! ScrollTop is REQUIRED !!! */}
							<ScrollTop/>
							<FragmentSupportingSwitch>
								{/* Admin  Routes*/}
								{isAdmin&&
									<>
										<Route path="/all-referrals">
											<AdminReferrals/>
										</Route>
									</>
								}
								{/* Account Owner Routes */}
								<>
									<Route path="/referrals">
										<Referrals/>
									</Route>
								</>
								{/* Chain Routes */}
								{isChain&&
									<>
										<Route path="/chain">
											<AdminDashboard />
										</Route>
										<Route path="/all-gyms">
											<AccountList type="gym" />
										</Route>
										<Route path="/adminDashboard">
											<AdminDashboard/>
										</Route>
									</>
								}
								{/* Gym Routes */}
								{isGym&&
									<>
										<Route path="/gym">
											<Compliance />
										</Route>
										<Route path="/trainers">
											<Trainers />
										</Route>
										<Route path="/gymmetricList">
											<GymMetricList />
										</Route>
									</>
								}
								<Route path="/gym-calendar">
									<GymCalendar/>
								</Route>
								{/* Chain/Gym routes*/}
								{(isChain||isGym)&&
									<>
										<Route path="/all-trainers">
											<AccountList type="trainer" />
										</Route>
									</>
								}
								{/* Chain/GymTrainer routes */}
								{(isChain||isGym||isTrainer)&&
									<>
										<Route path="/clients">
											<Clients />
										</Route>
										<Route path="/addNewClient">
											<AddNewClients />
										</Route>
										<Route path="/all-clients">
											<AccountList type="client" />
										</Route>
										<Route path="/programSettings">
											<ProgramSettings />
										</Route>
										<Route exact path="/programsAddEdit">
											<ProgramsAddEdit />
										</Route>
										<Route exact 
											path="/programsEdit" 
											component={ProgramsEdit}
										/>
										<Route 
											path="/clientEditor"
											component={ClientProfile}
										/>
										<Route exact path="/customAppSuccess">
											<CustomAppSuccess />
										</Route>
										<Route exact path="/clientEmails">
											<ClientEmails />
										</Route>
									</>
								}
								{/* Trainer Routes */}
								{isTrainer&&
									<Route path="/trainer">
										<ClientList />
									</Route>
								}
								{/* Client Routes */}
								{isClient&&
									<>
										<Route path="/client_dashboard">
											<TodaysEvents />
											<ClientCompliance />
											{shouldShowFeature('exercise_progress')&&<Progress />}
											{shouldShowFeature('progress_pictures')&&<Pictures />}
											{shouldShowFeature('achievements')&&<Achievements />}
										</Route>
									</>
								}
								{isProspect&&
									<>
										<Route path="/client_dashboard">
											<ProspectDashboard/>
										</Route>
									</>
								}
								{/* Shared Routes */}
								<Route path="/simplified_nutrition">
									<SimplifiedNutrition />
								</Route>
								<Route path="/max_schedule">
									<MaxClassSchedule />
								</Route>
							
							
								
								<Route path="/profile">
									<Profile />
								</Route>
								<Route path="/exerciseList">
									<ExerciseList />
								</Route>
								<Route path="/exercise_progress">
									<ViewExerciseProgress />
								</Route>
								<Route path="/wearables">
									<Wearables />
								</Route>
								<Route path="/muscleGroups">
									<MuscleGroups />
								</Route>
								<Route path="/messenger">
									<Messenger />
								</Route>
								<Route path="/foodlist">
									{user.isMAXUser?
										<MAXFoodList/>
										:
										<FoodList />
									}
								</Route>
								<Route path="/achievements">
									<Achievements />
								</Route>
								<Route path="/programs">
									<Programs />
								</Route>
								<Route path="/photo_reel">
									<PhotoReel />
								</Route>
								<Route path="/ProgressGraphGrid">
									<Metric />
								</Route>
								<Route path="/metricList">
									<MetricList />
								</Route>
								<Route path="/addprogress">
									<AddProgress />
								</Route>
								<Route path="/viewPictures">
									<ViewPictures />
								</Route>
								<Route path="/recipeList">
									<Recipes />
								</Route>
								<Route exact path="/resources">
									<ExternalResources />
								</Route>
								<Route path="/settings">
									<Settings />
								</Route>
								<Route
									path="/eventEditor"
									component={EventEditor}
								/>
								<Route
									path="/eventCreator"
									component={EventCreator}
								/>
								<Route path="/calendar">
									<Calendar />
								</Route>
								<Route path="/eventsView" component={EventList} />
								<Route path="/payment-setup" component={PaymentSetup} />
								<Route path="/parQ">
									<ParQ />
								</Route>
								<Route path="/classes">
									<LiveClasses />
								</Route>

								<Route exact path="/:pageAddress/blog/search/" render={() => <BlogSearch />} />

								<Route exact path="/:pageAddress/blog/:postSlug" >
									<SingleBlog />
								</Route>

								<Route exact path="/myBlog">
									<Blog />
								</Route>

								<Route exact path="/:pageAddress/blog/">
									<BlogLiveView />
								</Route>

								<Route exact path="/customForms">
									<CustomForms />
								</Route>

								<Route 
									component={OnboardingPipelineEditor}
									path="/onboarding-pipeline-editor"
									exact
								/>

								<Route exact path="/formEditor"
									component={FormEditor}
								/>

								<Route exact path="/recipe-editor" 
									component={RecipeEditor}
								/>

								<Route exact path="/trainerPageServices">
									<TrainerPageServices />
								</Route>

								<Route exact path="/merchandise">
									<Merchandise/>
								</Route>
								<Route path="/Scheduler">
									<Scheduler />
								</Route>
								<Route path="/cancel">
									<CancelAccount/>
								</Route>
								<Route path="/notification_dashboard">
									<NotificationDashboard/>
								</Route>
								<Route 
									component={FinancialsDashboard}
									path="/financials_dashboard"
								/>
								<Route 
									component={ProgramEditor} 
									path="/program-editor"
								/>
								<Route 
									component={PayInvoice}
									path="/pay-invoice"
									exact 
								/>
								<Route 
									component={OnDemand}
									path="/on-demand"
									exact 
								/>
								<Route 
									component={Timer}
									path="/timer"
									exact 
								/>
								<Route 
									component={CustomizationDashboard}
									path="/customization-dashboard"
									exact 
								/>
								<Route
									component={ProgressGraphGrid}
									path="/metric-graphs"
									exact
								/>
								<Route
									component={MultiFormsRoute}
									path="/purchase-forms"
									exact
								/>
								<Route
									component={AddClient}
									path="/add-client"
									exact
								/>
								<Route
									component={MyTrainer}
									path="/my-trainer"
									exact
								/>
								<Route
									component={Growth}
									path="/growth"
									exact
								/>
								<Route
									path="/ios-lite-setup"
									exact
								>
									<LiteIOS setup={true}/>
								</Route>
							</FragmentSupportingSwitch>
							<ApiStatus />
							<Onboarding />
							{(!mobileStatus) && <StickyChatToggle />}
							<MessageCenter />
							<VideoModal/>
							<UpdateBillingModal />
							<ResetCurrencyModal />
							<Route exact path="/recipes">
								<RecipesPublic/>
							</Route> 
							<Route exact path="/fitswai">
								<AIDemo mode="webview" />
							</Route>
							<Route exact path="/pwastart">
								<PWAStart/>
							</Route>
						</div>
					</div>
				</div>
				<AIDemo/>
				<CrashLogging/>
				<ResourceReferenceCreatorModal/>
				<ClientSessionsModal/>
				<MultiFormsModal/>
				<ProgramAssignModal/>
				<PipelineAssignModal/>
				<PipelineAssignmentsEditor/>
				<ProspectiveClientViewer/>
				<Modal
					onHide={() => {
						setShowUpgradeModal(false)
					}}
					show={showUpgradeModal}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							You are using an out of date browser!
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>In order to use all the features of FitSW.com, You'll need to upgrade to a modern browser.</p>
						<p>Checkout <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noopener noreferrer">Edge</a>. Microsoft's latest browser</p>
					</Modal.Body>
				</Modal>
			</div>
		</Router>
	)

}

export default App;
